import React from 'react';
import Helmet from 'react-helmet';

import optoutStore from 'modules/report/stores/optout';

import Header from './components/Header';
import Filter from './components/Filter';
import Table from './components/Table';
import { TODAY } from 'components/DateRangeButton';
import { ReportBody } from '@/components/reports/body';

const groupOptions = [
  { key: 'siteId', name: 'Site', keyImpression: 'siteId' },
  { key: 'publisherId', name: 'Publisher', keyImpression: 'publisherId' },
  { key: 'optoutdate', name: 'Day', keyImpression: 'optoutdate' },
  { key: 'domain', name: 'Domain', keyImpression: 'domain' },
  { key: 'origin', name: 'Origin', keyImpression: 'origin' },
];

class OptoutLayout extends React.Component {
  state = {
    filterOpen: false,
    params: {
      group: [
        { key: 'siteId', name: 'Site', keyImpression: 'siteId' },
        { key: 'publisherId', name: 'Publisher', keyImpression: 'publisherId' },
      ],
      filters: {
        searchStartDate: TODAY.start,
        searchEndDate: TODAY.end,
        siteId: null
      }
    }
  }

  loadData = async () => {
    await optoutStore.getSumary({ ...this.state.params });
    this.setState({ searchTerm: '' });
  }

  componentDidMount() {
    this.loadData();
  }

  handleClickFilter = () => {
    this.setState({ filterOpen: !this.state.filterOpen });
  }

  getGroupKeys = () => this.state.params.group.map(obj => obj.key);

  getGroupNames = () => this.state.params.group.map(obj => obj.name);

  handleChangeDates = ({ startDate, endDate }) => {
    let filters = this.state.params.filters;
    filters.searchStartDate = startDate;
    filters.searchEndDate = endDate;
    this.setState({ filters }, () => {
      if (startDate && endDate) {
        this.loadData();
      }
    });
  }

  handleFilterClose = () => {
    this.setState({ filterOpen: false });
  }

  handleFilterApply = (params) => {
    this.setState({
      params,
      filterOpen: false
    }, this.loadData);
  }

  updateParams = params => {
    const { searchStartDate, searchEndDate } = this.state.params.filters
    if (searchStartDate && searchEndDate) {
      params.searchStartDate = searchStartDate.format('YYYY-MM-DD')
      params.searchEndDate = searchEndDate.format('YYYY-MM-DD')
    }
  }

  render() {
    return (
      <>
        <Helmet title="Optout Summary" />
        <Header
          onClickFilter={this.handleClickFilter}
          onChangeDates={this.handleChangeDates}
          dates={{ startDate: this.state.params.filters.searchStartDate, endDate: this.state.params.filters.searchEndDate }}
          sync={this.loadData}
          isLoading={optoutStore.isLoading}
        />
        {this.renderFilter()}
        <ReportBody loading={optoutStore.isLoading}>
          <Table data={optoutStore.summary.data}
            updateParams={this.updateParams}
            groupKeys={this.getGroupKeys()}
            groupNames={this.getGroupNames()}
          />
        </ReportBody>
      </>
    );
  }

  renderFilter() {
    if (!this.state.filterOpen) {
      return null;
    }

    return (
      <Filter
        isOpen={this.state.filterOpen}
        onApply={this.handleFilterApply}
        onClose={this.handleFilterClose}
        groupOptions={groupOptions}
        params={this.state.params}
      />
    );
  }
}

export default OptoutLayout;
